export function renderHomePage(container) {
  if (!container) return;

  container.innerHTML = `
    <div class="wt-home">
      <!-- Hero Cover Section -->
      <section class="wt-hero-cover" style="background-image: linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.55)), url('/assets/father-and-son-g22f40107e_1920.jpg');">
        <div class="wt-hero-content">
          <h1 class="wt-hero-heading wt-hero-top">Don’t Do Life Alone</h1>
          <div class="wt-hero-spacer"></div>
          <h2 class="wt-hero-heading wt-hero-bottom">Walk Through Darkness Together</h2>
        </div>
      </section>

      <!-- Who Are We Section -->
      <section class="wt-section wt-who-we-are">
        <div class="wt-container text-center">
          <p class="wt-eyebrow">WHO ARE WE?</p>
          <h2 class="wt-statement">
            We are a community of believers committed to making disciples.
          </h2>
        </div>
      </section>

      <!-- Media & Text Block 1 (Midnight Gradient) -->
      <section class="wt-split-row wt-split-midnight">
        <div class="wt-split-text">
          <div class="wt-split-quote">
            <strong>We’ve been there.</strong> Life is hard to do alone. We strive to be a resource for you through the hard times.
          </div>
        </div>
        <div class="wt-split-media">
          <img src="/assets/martin-pechy-u-2g_UCBP4E-unsplash-1024x683.jpg" alt="Walking together in community" loading="lazy" />
        </div>
      </section>

      <!-- Media & Text Block 2 (Airy Blue) -->
      <section class="wt-split-row wt-split-reverse wt-split-light">
        <div class="wt-split-media">
          <img src="/assets/priscilla-du-preez-mKJUoZPy70I-unsplash-1024x683.jpg" alt="Fellowship and discipleship" loading="lazy" />
        </div>
        <div class="wt-split-text">
          <div class="wt-split-quote text-dark">
            <strong>We want to push you</strong> to fulfill your calling as a Disciple Maker.
            <div class="wt-founder-tag">– Joe Pattavina, Founder</div>
          </div>
        </div>
      </section>

      <!-- 3 Pillars Section: Body, Soul, Spirit -->
      <section class="wt-pillars-section">
        <div class="wt-container">
          <div class="wt-pillars-grid">
            
            <!-- Column 1: Body -->
            <div class="wt-pillar-col wt-col-body">
              <h3 class="wt-pillar-title">Body</h3>
              <p class="wt-pillar-scripture">
                Jesus said, “The eye is the lamp of the body. So, if your eye is healthy, your whole body will be full of light”
              </p>
              <div class="wt-pillar-divider"></div>
              <h4 class="wt-pillar-services-label">Our Services</h4>
              <ul class="wt-pillar-list">
                <li>Health</li>
                <li>Media</li>
                <li>Money</li>
                <li>Search</li>
              </ul>
            </div>

            <!-- Column 2: Soul (Middle Section) -->
            <div class="wt-pillar-col wt-col-soul">
              <h3 class="wt-pillar-title">Soul</h3>
              <p class="wt-pillar-scripture">
                Mary said, “My soul glorifies the Lord and my spirit rejoices in God my Savior.”
              </p>
              <div class="wt-pillar-divider"></div>
              <h4 class="wt-pillar-services-label">Our Services</h4>
              <ul class="wt-pillar-list">
                <li>
                  <a href="#course" class="wt-pillar-link" title="Discipleship 101 Cohorts and Curriculum">
                    Disciple Making
                  </a>
                </li>
                <li>
                  <a href="#praytogether" class="wt-pillar-link" title="PrayTogether Android App & Guides">
                    PrayTogether
                    <img src="/assets/new.png" alt="NEW" class="wt-badge-new" />
                  </a>
                </li>
                <li>
                  <a href="#studies" class="wt-pillar-link" title="StudyTogether Bible Studies">
                    StudyTogether
                    <img src="/assets/new.png" alt="NEW" class="wt-badge-new" />
                  </a>
                </li>
                <li>
                  <a href="#blog" class="wt-pillar-link" title="Walk Together Ministries Blog">
                    Blog
                    <img src="/assets/new.png" alt="NEW" class="wt-badge-new" />
                  </a>
                </li>
                <li>Marriage</li>
              </ul>
            </div>

            <!-- Column 3: Spirit -->
            <div class="wt-pillar-col wt-col-spirit">
              <h3 class="wt-pillar-title">Spirit</h3>
              <p class="wt-pillar-scripture">
                Paul said, “In order that the righteous requirement of the law might be fully met in us, who do not live according to the flesh but according to the Spirit.”
              </p>
              <div class="wt-pillar-divider"></div>
              <h4 class="wt-pillar-services-label">Our Services</h4>
              <ul class="wt-pillar-list">
                <li>Missions</li>
                <li>Needs and Service Opportunities</li>
                <li>
                  <a href="https://walktogethercare.org" target="_blank" rel="noopener noreferrer" class="wt-pillar-link" title="Walk Together Care Nonprofit Organization">
                    Walk Together Care (Nonprofit)
                    <i class="fa-solid fa-arrow-up-right-from-square wt-ext-icon"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      <!-- Our Beliefs Section -->
      <section class="wt-section wt-beliefs">
        <div class="wt-container text-center">
          <p class="wt-eyebrow">OUR BELIEFS</p>
          <h2 class="wt-statement wt-statement-beliefs">
            That by trusting in Jesus Christ as God’s offer of forgiveness, we will be saved from sin’s penalty and spend eternity in heaven.
          </h2>
        </div>
      </section>

      <!-- Interested in Discipleship Section -->
      <section class="wt-section wt-cta-dark">
        <div class="wt-container text-center">
          <p class="wt-eyebrow text-white-50">INTERESTED IN DISCIPLESHIP?</p>
          <h2 class="wt-cta-title">Discover for Yourself</h2>
          <div class="wt-cta-btn-wrap">
            <a href="#course" class="wt-btn-pill">Find Out More</a>
          </div>
        </div>
      </section>

      <!-- Nonprofit Spotlight Banner -->
      <section class="wt-care-banner">
        <div class="wt-container">
          <div class="wt-care-box">
            <div class="wt-care-info">
              <span class="wt-care-tag">501(c)(3) Partner</span>
              <h3>Walk Together Care</h3>
              <p>Meeting practical, tangible needs in our communities with Christ's unconditional love and support.</p>
            </div>
            <a href="https://walktogethercare.org" target="_blank" rel="noopener noreferrer" class="wt-btn-care">
              Visit walktogethercare.org <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </a>
          </div>
        </div>
      </section>
    </div>
  `;
}
